import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66aca424"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "account-confirmation-email",
  class: "center-card with-margin"
}
const _hoisted_2 = {
  key: 0,
  class: "email-sent"
}
const _hoisted_3 = { class: "email-sent-message" }
const _hoisted_4 = { key: 1 }

import { toRefs } from 'vue'

  import EmailSent from '@/components/Common/Images/EmailSent.vue'
  import UserAuthForm from '@/components/User/UserAuthForm.vue'

  interface Props {
    action: string
  }
  
export default /*#__PURE__*/_defineComponent({
  name: 'AccountConfirmationEmail',
  props: {
    action: null
  },
  setup(__props: any) {

const props = __props as {
    action: string
  }

  

  const { action } = toRefs(props)

return (_ctx: any,_cache: any) => {
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(action) === 'email-sent')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(EmailSent),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('user.ACCOUNT_CONFIRMATION_SENT')), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_Card, null, {
            title: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('user.RESENT_ACCOUNT_CONFIRMATION')), 1)
            ]),
            content: _withCtx(() => [
              _createVNode(UserAuthForm, { action: _unref(action) }, null, 8, ["action"])
            ]),
            _: 1
          })
        ]))
  ]))
}
}

})